// extracted by mini-css-extract-plugin
export default {"labelContainer":"UserThemeSetting-module__labelContainer--8lZU9","formFooter":"UserThemeSetting-module__formFooter--SxJD4"};